module.exports = __webpack_public_path__ + "img/master-visaul.3363c3a9.png";